// extracted by mini-css-extract-plugin
module.exports = {"footer":"FileParser_footer__9Q_Td"};